import {Component, OnInit} from '@angular/core';
import {AuthServerProvider} from '../common.module/auth/auth-jwt.service';
import {Router} from '@angular/router';
import {UserAuth} from '../common.module/auth/user-auth.model';
import {ToastService} from 'ng-uikit-pro-standard';
// import {ProvidersService} from '../portal.index.module/service/providers.service';
import {ConfiguracionGeneralService} from '../admin.configuracion-general.module/service/configuracion-general.service';
import {ConfiguracionGeneralModel} from '../admin.configuracion-general.module/service/configuracion-general.model';
import {AuthExtendedResource} from '../main-login.component/service/auth-extended.resource';

@Component({
  selector: 'app-left-slider',
  templateUrl: './sidebar.component.html'
})

export class SidebarComponent implements OnInit {
  user: UserAuth;
  public configuracion: ConfiguracionGeneralModel = {};

  constructor(private authServerProvider: AuthServerProvider,
              private router: Router,
              //@TODO Variable no econtrada
              // private providersService: ProvidersService,
              private configuracionGeneralService: ConfiguracionGeneralService,
              private authResource: AuthExtendedResource,
              private toastMsg: ToastService) {
    this.user = authServerProvider.getUserDecoded();
    console.log('usuario obtenido');
    console.log(this.user);
  }

  /**
   * Validación de roles a ver la opción.
   * @param rols: Array
   */
  validateRole(rols: any[]) {
    return true;
  }

  signOut() {
    this.authResource.logout().then(aVoid => {
      console.log('Cerrado de sesión guardado en bitácora');
    }, err => console.error(err));
    this.authServerProvider.logout();
    this.router.navigate(['/login']);
  }


  generatePublicFileWith64(idFilePublic) {
    // this.providersService.getPublicFile(idFilePublic).then(res => {
    //   console.log(res[0]);
    //   if (res[0].file_public_64 != null) {
    //     /* console.log('Descargando ' + res[0].name);
    //      this.toastMsg.success('Descargando ' + res[0].name);*/
    //     this.downloadFile(res[0].name, res[0].file_public_64);
    //   } else {
    //     this.toastMsg.error('El archivo no esta disponible por el momento');
    //   }
    // }, err => {
    //   if (err.body.message) {
    //     this.toastMsg.error(err.body.message);
    //   } else {
    //     this.toastMsg.error('Error en la visualización del PDF');
    //   }
    // });
  }

  downloadFile(filename, base64) {
    const dataURI = this.base64ToArrayBuffer(base64);
    const blob = new Blob([dataURI], {type: 'application/pdf'});
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const elem = window.document.createElement('a');
      window.open(window.URL.createObjectURL(blob), '_blank');
    }
  }

  base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  ngOnInit(): void {
    this.configuracionGeneralService.obtenerConfiguracionGeneral().then(configuracion => {
      this.configuracion = configuracion;
    });
  }
}

